/* eslint-disable import/prefer-default-export */
import _ from "lodash";
import currenciesMap from "@/currenciesMap.json";

export const formatPrice = (price: number, currency: string) =>
  `${price.toFixed(2)}${_.get(currenciesMap, currency, currency)}`;
